import { useContext, useEffect } from 'react';
import { camelizeKeys } from 'humps';
import { useOtherSettings } from '@namespace/cms';
import { socketSubscribe, socketUnsubscribe } from '@namespace/socket';
import { UserContext } from '../../context';

export const useUserOptions = () => {
  const [, { UPDATE_CURRENCY }] = useContext(UserContext);
  const { crypto = {} } = useOtherSettings();
  const { isNeedLoadRates = false } = crypto;

  useEffect(() => {
    if (isNeedLoadRates) {
      socketSubscribe({
        name: 'get_user_options',
        types: ['user_options_changed'],
        callback: ({ data }) => {
          const normalizedData = camelizeKeys(data);
          if (normalizedData.walletCurrency || normalizedData.bettingCurrency) {
            UPDATE_CURRENCY(normalizedData);
          }
        }
      });

      return () =>
        socketUnsubscribe({
          name: 'get_user_options'
        });
    }

    return () => {};
  }, []);
};
